import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import News from "./pages/News";
import Gallery from "./pages/Gallery";
import Videos from "./pages/Videos";
import Login from "./components/Login";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
// import Sports from "./pages/Sports";
// import Worksheets from "./pages/Worksheets";
// import Scholarships from "./pages/Scholarships";
import ExamPaper from './pages/ExamPaper';
import ExamKey from './pages/ExamKey'
import ExamSolution from './pages/ExamSolution'
import PdfUploader from "./components/DashboardComponents/PdfUploadComponent/PdfUploader";
import Home from "./pages/Home";
import DashBoard from "./components/DashboardComponents/Index";
import Layout from "./pages/Layout";
import UserWidgets from "./components/DashboardComponents/UserWidgets";
import "./App.css";
import EditAboutPage from "./components/DashboardComponents/AboutComponent/EditAboutPage";
import EditContact from "./components/DashboardComponents/ContactComponent/EditContact";
import EditFlashNews from "./components/DashboardComponents/FlashNewsComponent/EditFlashNews";
import EditHomePage from "./components/DashboardComponents/HomePageComponent/EditHomePage";
import UploadNews from "./components/DashboardComponents/UploadNewsComponent/UploadNews";
import UploadSlides from "./components/DashboardComponents/UploadSlideComponent/UploadSlides";
import HeaderImageUploader from "./components/DashboardComponents/HeaderImageUploadComponent/HeaderImageUploader";
import LinkUploader from "./components/DashboardComponents/LinkUploadComponent/LinkUploader";
import EditScrollMessage from "./components/DashboardComponents/ScrollingMsgComponent/EditScrollMessage";
import useGlobalAppContext from "./hooks/useGlobalAppContext";
import PageNotFound from "./pages/PageNotFound";
import UploadGallary from "./components/DashboardComponents/UploadImageComponent/UploadGallary";
import UploadPaper from "./components/DashboardComponents/ExamPaper/UploadPaper";
import UploadKey from "./components/DashboardComponents/ExamPaperKey/UploadKey";
import UploadSolution from './components/DashboardComponents/ExamPaperSolution/UploadSolution'
import VideoLinkManager from "./components/DashboardComponents/UploadVideoLinks/VideoLinkManager";
const App = () => {
  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem("auth");
    return storedAuth ? JSON.parse(storedAuth) : true;
  });

  const [role, setRole] = useState(() => {
    return localStorage.getItem("role") || "admin";
  });

  const [userdata, setUserData] = useState(() => {
    const storedUser = localStorage.getItem("userdata");
    return storedUser ? JSON.parse(storedUser) : { username: "kkcc" };
  });

  // Update localStorage when states change
  useEffect(() => {
    localStorage.setItem("auth", JSON.stringify(auth));
  }, [auth]);

  useEffect(() => {
    localStorage.setItem("role", role);
  }, [role]);

  useEffect(() => {
    localStorage.setItem("userdata", JSON.stringify(userdata));
  }, [userdata]);
  const store = { auth, setAuth, role, setRole, userdata, setUserData };
  return (
    <useGlobalAppContext.Provider value={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/exam-paper" element={<ExamPaper />} />
            <Route path="/exam-key" element={<ExamKey />} />
            <Route path="/exam-solution" element={<ExamSolution />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/login" element={<Login />} />
          </Route>
          {auth && (
            <Route
              path="/dashboard"
              element={
                <DashBoard
                // setAuth={setAuth}
                // setRole={setRole}
                // setUserData={setUserData}
                />
              }
            >
              <Route index element={<UserWidgets />} />
              <Route path="/dashboard/flash-news" element={<EditFlashNews />} />
              <Route
                path="/dashboard/scrolling-message"
                element={<EditScrollMessage />}
              />

              <Route
                path="/dashboard/home-page-data"
                element={<EditHomePage />}
              />
              <Route path="/dashboard/about-data" element={<EditAboutPage />} />
              <Route path="/dashboard/contact-data" element={<EditContact />} />
              <Route path="/dashboard/upload-gallary" element={<UploadGallary />} />
              <Route path="/dashboard/upload-news" element={<UploadNews />} />
              <Route
                path="/dashboard/upload-slide"
                element={<UploadSlides />}
              />
              <Route
                path="/dashboard/upload-header-image"
                element={<HeaderImageUploader />}
              />
              <Route path="/dashboard/exam-papers" element={<UploadPaper />} />
              <Route path="/dashboard/exam-keys" element={<UploadKey />} />
              <Route path="/dashboard/exam-solutions" element={<UploadSolution />} />
              <Route
                path="/dashboard/upload-links"
                element={<LinkUploader />}
              />
                     <Route
                path="/dashboard/video-links"
                element={<VideoLinkManager />}
              />
            </Route>
          )}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </useGlobalAppContext.Provider>
  );
};

export default App;
